export default "__VITE_ASSET__f090abfb__"